import { Link, useLocation } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <title>页面未找到 - 善良的小姨子在线</title>
      <meta name="robots" content="noindex" />
      <div className="relative mx-auto flex max-w-6xl flex-col items-center justify-center px-4 py-24 text-center md:px-6 md:py-32">
        <p className="select-none font-heading text-7xl font-black text-primary-100 md:text-9xl">404</p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
          抱歉，这个页面走丢了
        </h1>
        <p className="mt-2 max-w-md text-sm text-foreground-600">
          你访问的地址 <span className="font-mono text-foreground-800">{location.pathname}</span> 不存在或已被移除，不妨回到首页继续追剧。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/category"
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 cursor-pointer"
          >
            <i className="ri-compass-3-line"></i>
            浏览分类
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}